import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

let defaultLang = 'en';
try {
  // to be added when configuring multi-lingual
  defaultLang = (navigator.language || navigator.userLanguage).split('-')[0] == 'te' ? 'te' : 'en';
  // eslint-disable-next-line no-empty
} catch (error) {}

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

export default new VueI18n({
  locale: defaultLang,
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
});
